import { render, staticRenderFns } from "./WeChatLoginPage.vue?vue&type=template&id=5bf3f3b9&scoped=true&"
import script from "./WeChatLoginPage.vue?vue&type=script&lang=js&"
export * from "./WeChatLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3f3b9",
  null
  
)

export default component.exports